import { collections } from './stickers/index';

// Export flattened array of all stickers
export const stickers = Object.values(collections).flat();